export enum EPaymentFrequency {
    Monthly = 1,
    BiMonthly = 2,
    Fortnight = 3,
    Weekly = 4
}
